import { render, staticRenderFns } from "./howToGetInvoice.vue?vue&type=template&id=36869215&scoped=true"
import script from "./howToGetInvoice.vue?vue&type=script&lang=js"
export * from "./howToGetInvoice.vue?vue&type=script&lang=js"
import style0 from "./howToGetInvoice.vue?vue&type=style&index=0&id=36869215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36869215",
  null
  
)

export default component.exports